<div class="d-flex justify-content-between">
    <h2 mat-dialog-title>{{ 'DOMAIN_STARTSCHERM.HOEDANIGHEID.CHOOSE' | i18n }}</h2>
</div>
<mat-dialog-content style="height: 380px">
    <baas-tile-list [tiles]="tiles()"></baas-tile-list>
</mat-dialog-content>
